import React from 'react';
import { Input, Alert } from 'antd';
import PropTypes from 'prop-types';
import s from './style.less';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div>
    <label htmlFor={input.name}>
      <div>{label}</div>
      <div className={s.vrm_container}>
        <div className={s.gb_icon} />
        <Input
          {...input}
          className={`${s.vrm} ${touched && error ? s.input_invalid : ''}`}
          id={input.name}
          placeholder="ENTER REG"
          type={type}
        />
        {touched && error && <Alert message={error} type="error" />}
      </div>
    </label>
  </div>
);
renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
};

export default renderField;
